<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { Tooltip } from '@svelte-plugins/tooltips';

    export let items;
    let selectedItem = null;
    const dispatch = createEventDispatcher();

    onMount(() => {
        if (items.length > 0) {
            selectedItem = items[0];
            dispatch('itemSelected', selectedItem);
        }
    });

    function selectItem() {
        dispatch('itemSelected', selectedItem);
    }
</script>

<div class="warehouse-select">
    {#each items as item, index}
        <label class="select-item">
            <input
              class="radio_animated"
              type="radio"
              name="warehouseItem"
              bind:group={selectedItem}
              value={item}
              on:change={selectItem}
              checked={selectedItem === item}>
            <i class="fad fa-fw fa-warehouse"></i>
            <span class="item-text">
                <h5>Sklad {item.supplier_id} <span>{item.stock}ks</span></h5>
                {#if item.manufacture_year}
                    <small>Rok výroby: {item.manufacture_year}</small>
                {:else}
                    <small>Rok výroby:
                        <Tooltip maxWidth={500} animation="" content="Rok výroby tejto pneumatiky nemusí byť presný, nakoľko ho dodávateľ neudáva, no zvyčajne sa jedná o rok 2024. Ak vyžadujete špecifický rok výroby tejto pneumatiky, napíšte to prosím do poznámky pri objednávke.">
                            <u>2024</u>
                        </Tooltip>
                    </small>
                {/if}
            </span>
            <span class="item-price">
                <span>{item.price.toFixed(2)}€</span>
            </span>
        </label>
    {/each}
</div>

<style>
    .warehouse-select {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        height: 100%;
    }
    .select-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem .75rem 1rem 1rem;
        border-radius: .4rem;
        border: 1px solid var(--color-slate-200);
        background: var(--color-slate-50);
        cursor: pointer;
        transition: .1s linear;
    }
    .select-item:hover {
        border-color: var(--color-slate-400);
    }
    .select-item:hover .radio_animated:after {
        border-color: var(--color-slate-300);
    }
    .select-item:has(input:checked) {
        border-color: #E65025;
        background: #FDEEEA;
    }
    .select-item .item-text {
        display: flex;
        flex-direction: column;
    }
    .select-item .item-text h5 {
        line-height: 1.25rem;
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: .25rem;
        color: var(--color-slate-600);
    }
    .select-item .item-text h5 span {
        font-size: .9rem;
        padding: .15rem .35rem;
        border-radius: .25rem;
        margin-left: .25rem;
        background-color: var(--color-slate-200);
    }
    .select-item .item-text small {
        line-height: 1.25rem;
        font-size: .9rem;
        color: var(--color-slate-500);
    }
    .select-item .item-text u {
        cursor: help;
        text-decoration: none;
        border-bottom: 1px dashed var(--color-slate-500);
    }
    .select-item .item-price {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-left: auto;
    }
    .select-item .item-price span {
        font-weight: 700;
        color: var(--color-secondary);
    }
</style>